/**
 * Fetches a score-based game's global all-time leaderboard. Enabled only when the sheet is open and a
 * game tab is selected, so opening the warmup hub never triggers the request. The server is the source
 * of truth for ranking, the viewer's standing, and the filtered total.
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchGameLeaderboard } from '../helpers/gamesApi';
import type { GameLeaderboardData } from '../helpers/gamesApi';

const STALE_TIME_MS = 30 * 1000;

export function useGameLeaderboard(gameKey: string | null, enabled: boolean) {
  const apiClient = useApiClient();
  return useQuery<GameLeaderboardData>({
    queryKey: ['gameLeaderboard', gameKey],
    queryFn: () => fetchGameLeaderboard(apiClient, gameKey as string),
    enabled: enabled && !!gameKey,
    staleTime: STALE_TIME_MS,
  });
}
